import Map from 'scripts/models/base/map';

export default Map.extend({
    define: {
        type: {
            type: 'string',
            value: 'generic'
        },
        url: {
            type: 'string',
            value: ''
        }
    }
});